import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@chakra-ui/react';

interface IOneButtonModal {
  isOpen: boolean;
  buttonText: string;
  onClose: () => void;
  onClickButton: () => void;
  children: React.ReactNode;
}

function OneButtonModal(props: IOneButtonModal) {
  const onButton = () => {
    props.onClickButton();
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={'34px'}>
        <ModalBody px={'0px'}>{props.children}</ModalBody>
        <ModalFooter justifyContent={'center'} px={'11px'}>
          <Button
            colorScheme={'black_button'}
            w={'100%'}
            h="46px"
            fontSize={'1rem'}
            fontWeight="semibold"
            borderRadius={'base'}
            onClick={onButton}>
            {props.buttonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
export default OneButtonModal;
